import quickFetch from 'quick-fetch';

export const makeGroupsWithPropertiesQuickFetchKey = ({
  portalId = quickFetch.getPortalId(),
  frameworkTypeIdentifier,
  query,
}: {
  portalId?: string;
  frameworkTypeIdentifier: string;
  query?: { showHighlySensitiveProperties?: boolean };
}) =>
  `frameworkDataSchemaResolvers-${portalId}-properties-${frameworkTypeIdentifier}-${
    query?.showHighlySensitiveProperties || false
  }`;

export const getGroupsWithPropertiesFetchUrl = ({
  frameworkTypeIdentifier,
  query,
}: {
  frameworkTypeIdentifier: string;
  query?: { showHighlySensitiveProperties?: boolean };
}) =>
  `/properties/v4/groups/${encodeURIComponent(
    frameworkTypeIdentifier
  )}/properties?includeFieldLevelPermission=true${
    query?.showHighlySensitiveProperties
      ? '&showHighlySensitiveProperties=true'
      : ''
  }`;

export const makeFrameworkTypesQuickFetchKey = ({
  portalId = quickFetch.getPortalId(),
  family,
}: {
  portalId?: string;
  family: string;
}) => `frameworkDataSchemaResolvers-${portalId}-frameworkTypes-${family}`;

export const makeFrameworkTypesFetchUrl = ({
  family,
}: {
  family: 'objects' | 'events';
}) =>
  family === 'objects'
    ? '/customer-object-types/v1/for-portal'
    : '/inbounddb-meta/v1/object-types/events/for-portal';

export const makePropertyMetadataEntriesFetchKey = ({
  frameworkTypeIdentifier,
  appSettingName,
  portalId = quickFetch.getPortalId(),
}: {
  portalId?: string;
  frameworkTypeIdentifier: string;
  appSettingName: string;
}) =>
  `frameworkDataSchemaResolvers-${portalId}-propertyMetadataEntries-${frameworkTypeIdentifier}-${appSettingName}`;

export const makePropertyMetadataEntriesFetchUrl = ({
  frameworkTypeIdentifier,
  appSettingName,
}: {
  frameworkTypeIdentifier: string;
  appSettingName: string;
}) =>
  `/framework-builder/v1/read/metadata/property/${encodeURIComponent(
    frameworkTypeIdentifier
  )}/${encodeURIComponent(appSettingName)}`;

export const makePipelinesFetchKey = ({
  frameworkTypeIdentifier,
  portalId = quickFetch.getPortalId(),
}: {
  frameworkTypeIdentifier: string;
  portalId?: string;
}) =>
  `frameworkDataSchemaResolvers-${portalId}-pipelines-${frameworkTypeIdentifier}`;

export const makePipelinesFetchUrl = ({
  frameworkTypeIdentifier,
}: {
  frameworkTypeIdentifier: string;
}) =>
  `/pipelines/v2/pipelines/${encodeURIComponent(
    frameworkTypeIdentifier
  )}?includeApprovalStageStatus=true&includePermissions=true`;

export const makeAssociationDefinitionsFetchKey = ({
  frameworkTypeIdentifier,
}: {
  frameworkTypeIdentifier: string;
}) => `associationDefinitions-${frameworkTypeIdentifier}`;

export const makeTypeMetadataEntriesFetchKey = ({
  portalId = quickFetch.getPortalId(),
  appSettingNames,
}: {
  portalId?: string;
  appSettingNames: string[];
}) =>
  `frameworkDataSchemaResolvers-${portalId}-typeMetadataEntries-${appSettingNames
    .slice()
    .sort()
    .join(',')}`;

export const makeTypeMetadataEntryFetchKey = ({
  portalId,
  appSettingName,
}: {
  portalId?: string;
  appSettingName: string;
}) =>
  makeTypeMetadataEntriesFetchKey({
    portalId,
    appSettingNames: [appSettingName],
  });

export const makeTypeMetadataEntriesFetchUrl = () =>
  '/framework-builder/v1/read/metadata/type/all/batch';
